export default "__VITE_ASSET__1YcK9YW0__"